import styles from './MenuHeaderNavigation.module.scss'
import NTVLogo from '@/components/Logo/NTVLogo'
import { Link } from '@/components/Link'
import { AreaItem } from '@/types/cms/AreaItem'
import PushButton from '@/components/PushButton/PushButton'
import AppContext from '@/types/context'
import { DarkLightModeToggle } from '@/components/DarkLightModeToggle'
import { Icon } from '@/components/Icon'

type MenuHeaderNavigationProps = {
  item: AreaItem
  context: AppContext
}

const MenuHeaderNavigation = ({ item, context }: MenuHeaderNavigationProps) => {
  return (
    <nav className={styles.navigation} data-cy="widget-menu-header-navigation">
      <div className={styles.container}>
        <div className={styles['left-block']}>
          <Link href="/" className={styles.link} target="_blank">
            <Icon name="arrowLeft" size={18} />
            <span>ntv.de</span>
          </Link>
        </div>
        <div className={styles['right-block']}>
          <DarkLightModeToggle context={context} />
          <PushButton context={context} />
        </div>
      </div>
    </nav>
  )
}

export default MenuHeaderNavigation
